//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        ibsdata: [],
        searchRequest: null,
      },

      mutations: {
        updateibsdata(state, ibsdata) {
          state.ibsdata= ibsdata;
        },
        updateSearchibsdataRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async loadibsdata({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))

          if (requestToSend.apptDateFrom)
          {
            requestToSend.apptDateFrom = dateFormat.getLocalDateOnly(requestToSend.apptDateFrom);
          }
          if (requestToSend.apptDateTo)
          {
            requestToSend.apptDateTo = dateFormat.getLocalDateOnly(requestToSend.apptDateTo);
          }

          if (requestToSend.po_lsdFrom)
          {
            requestToSend.po_lsdFrom = dateFormat.getLocalDateOnly(requestToSend.po_lsdFrom);
          }
          if (requestToSend.po_lsdTo)
          {
            requestToSend.po_lsdTo = dateFormat.getLocalDateOnly(requestToSend.po_lsdTo);
          }
          console.log(requestToSend);
          const st = performance.now();
          //const result = await api.post('/api/w/fsi/IBSlist', requestToSend);
          const result = await newAPIPost('/api/w/fsi/IBSlist', requestToSend);
          commit('updateSearchibsdataRequest', fallbackRequest);
          console.log(JSON.stringify(result));
          return commit('updateibsdata', result);
                },
      },

      getters: {
        getibsdata: state => state.ibsdata,
      },
}
